import isEmpty from 'lodash/isEmpty';
import React from 'react';
import type { IWeekData, IWeekDay } from '@/Interfaces/Data';

import styles from './styles.module.scss';

interface Props {
  weekDay: IWeekDay;
  hours: IWeekData[];
}

function TimeCard({ weekDay, hours }: Props) {
  return (
    <div className={styles.date}>
      <h3>{weekDay.shortName}</h3>

      {isEmpty(hours) ? (
        <p>
          <span>--:--</span> / <span>--:--</span>
        </p>
      ) : (
        hours.map((hour, index) => (
          <p key={index}>
            <span>{hour.horaInicial}</span> / <span>{hour.horaFinal}</span>
          </p>
        ))
      )}
    </div>
  );
}

export default TimeCard;
